import { createSlice } from "@reduxjs/toolkit";

export const eventSlice = createSlice({
  name: "events",
  initialState: {
    events: [],
    loading: false,
    error: null,
    attendees: {
      eventId: undefined,
      userAthlete: undefined,
    },
  },
  reducers: {
    eventsSearchAction: (state, action) => {
      state.events = action.payload;
    },
    eventLoadingAction: (state, action) => {
      state.loading = action.payload;
    },
    eventErrorAction: (state, action) => {
      state.error = action.payload;
    },
    setAttendees: (state, action) => {
      state.attendees.eventId = action.payload.eventId;
      state.attendees.userAthlete = action.payload.userAthlete;
    },

    addEventAction: (state, action) => {
      state.events.push(action.payload);
    },

    updateJerseyNumberAction: (state, action) => {
      const { userId, jerseyNumber } = action.payload;
      if (state.attendees.userAthlete.userId === userId) {
        state.attendees.userAthlete.jerseyNumber = jerseyNumber;
      }
      state.events = state.events.map((event) => {
        return {
          ...event,
          attendees: Array.isArray(event.attendees)
            ? event.attendees.map((athlete) =>
                athlete.userId === userId
                  ? { ...athlete, jerseyNumber }
                  : athlete,
              )
            : [],
        };
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  eventsSearchAction,
  eventLoadingAction,
  eventErrorAction,
  setAttendees,
  addEventAction,
  updateJerseyNumberAction,
} = eventSlice.actions;

export default eventSlice.reducer;
